module.exports = __webpack_public_path__ + "static/img/11areaA_13.1308153.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/11areaA_13.png
// module id = 890
// module chunks = 1